<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1050px'>
    <el-form v-loading='formLoading' :model='form' label-width='180px' label-position='right'
             ref='ruleForm' class='elForm p10'>
      <div-border label='质损信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='24'>
            <el-form-item label='质损编号：'>
              <span>{{ form.number |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='发运日期：'>
              <span>{{ form.massLossTime |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='邮件报备日期：'>
              <span>{{ form.reportingDate |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='车型：'>
              <span>{{ form.model |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='车架号：'>
              <span>{{ form.frameNumber |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='出发地：'>
              <span>{{ form.startAddress |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='目的地：'>
              <span>{{ form.endAddress |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='运输方式：'>
              <span>{{ form.taskMode ? '水路' : '公路' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='供应商：'>
              <span>{{ form.taskSupplierName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='拖车牌号：'>
              <span>{{ form.transportValue |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='司机姓名：'>
              <span>{{ form.taskPeopleName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='质损类型：'>
              <span>{{ form.typeName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='质损部位：'>
              <span>{{ form.detailDesc |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='质损部位（位置）：'>
              <span>{{ form.partName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='质损情况：'>
              <span>{{ form.situation |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='维修内容：'>
              <span>{{ form.maintainContent |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='质损环节：'>
              <span>{{ form.link |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='经销商：'>
              <span>{{ form.distributor |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='收车人：'>
              <span>{{ form.carReceiver |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='联系电话：'>
              <span>{{ form.contactRmber |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='定损金额：'>
              <span>{{ form.pricingAmount |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='降价金额：'>
              <span>{{ form.priceReductionAmount |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='买断金额：'>
              <span>{{ form.buyoutAmount |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='发票号码：'>
              <span>{{ form.invoiceNo |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='发票金额：'>
              <span>{{ form.invoicePrice |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='发票类型：'>
              <span>{{ form.invoiceType |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='开票日期：'>
              <span>{{ form.invoiceTime |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='开票单位：'>
              <span>{{ form.invoiceCompany |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='收到发票日期：'>
              <span>{{ form.invoiceReceivedDate |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='是否处罚：'>
              <span>{{ form.isPunish == 1 ? '是' : (form.isPunish == 0 ? '否' : '无') }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='处罚对象：'>
              <span>{{ form.punishObj |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='处罚单位：'>
              <span>{{ form.punishCompany |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='处罚金额：'>
              <span>{{ form.punishAmount |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='扣款时间：'>
              <span>{{ form.deductionTime |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='索赔资料邮寄重庆时间：'>
              <span>{{ form.mailingTime |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='付款时间：'>
              <span>{{ form.paymentTime |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='财务付款金额：'>
              <span>{{ form.paymentPrice |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='向保险公司索赔时间：'>
              <span>{{ form.claimCompensationDate |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='保险公司回款金额：'>
              <span>{{ form.receivableAmount |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='保险公司回款时间：'>
              <span>{{ form.wts |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='保单号：'>
              <span>{{ form.policyNumber |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='处理进度：'>
              <span>{{ form.speedOfProgress |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='备注：'>
              <span>{{ form.remarks |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='品牌：'>
              <span>{{ form.brand |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='发票：'>
              <span>{{ form.invoice |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='向垫付单位回款时间：'>
              <span>{{ form.collectionTime |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='付款方：'>
              <span>{{ form.payer |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='责任方：'>
              <span>{{ form.responsibleParty |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='责任单位：'>
              <span>{{ form.responsibleUnit |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='卸船日期：'>
              <span>{{ form.unloadingTime |dateFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='船名：'>
              <span>{{ form.shipName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='有无交接记录：'>
              <span>{{ form.handoverRecord |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='编号：'>
              <span>{{ form.numberBh |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='二级备注：'>
              <span>{{ form.remarksTwo |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='核对项目：'>
              <span>{{ form.checkItems |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='保险公司赔付金额：'>
              <span>{{ form.compensationAmount |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='我司承担金额：'>
              <span>{{ form.commitment |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='航向：'>
              <span>{{ form.azimuth |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label='质损图片：'>
              <el-image
                v-for="(item,index) in form.attachmentList"
                :key="index"
                style="width: 100px; height: 100px;margin-right:10px; "
                :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item.id)+'&access_token='+token"
                :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item.id)+'&access_token='+token]"
                fit="cover"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='操作记录' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='form.operateRecordList'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='createTime' label='操作时间' align='center' width='160px'/>
          <el-table-column prop='operateType' label='操作类型' align='center'/>
          <el-table-column prop='operationName' label='操作人' align='center'/>
          <el-table-column prop='remark' label='备注' align='center'/>
        </el-table>
      </div-border>
    </el-form>
  </el-dialog>
</template>

<script>
import divBorder from '@/components/divBorder.vue';
import {qualityDamageDetail} from "@/service/vehiclelog";
import {baseImgUrl} from "@/config/env";
import {getSessionStore} from "@/config/mUtils";

export default {
  name: 'qualityLossListInfo',
  components: {divBorder},
  data() {
    return {
      dialogTitle: '详情',
      dialogVisible: false,
      defaultForm: {},
      form: {},
      tableLoading: false,
      tableData: [],
      total: 0,
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      formLoading: false,
      baseImgUrl: baseImgUrl+ '/',
      token:getSessionStore('token'),
    };
  },
  filters: {
    valFormat(str) {
      if (str) {
        return str;
      } else {
        return '无';
      }
    },
    dateFormat(str) {
      if (str) {
        return str.substring(0, 10);
      } else {
        return '无';
      }
    },
  },
  mounted() {
    this.defaultForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    dialogOpen(row) {
      // this.form = row;
      this.getDetails(row.id)
      this.dialogVisible = true;
    },
    async getDetails(id) {
      this.formLoading = true
      const {status, message, data} = await qualityDamageDetail(id)
      this.formLoading = false
      if (status !== 0) return this.$message.warning(message)
      console.log(data);
      this.form = data;
    },
    dialogClose() {
      this.dialogVisible = false;
      this.form = JSON.parse(JSON.stringify(this.defaultForm));
    },
  },
};
</script>

<style lang='scss' scoped>
.elForm {
  max-height: 600px;
  overflow: auto;
}
</style>
